import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Welcome from '../views/Welcome.vue'
import EquipmentTable from '../components/EquipmentTable.vue'
import InventoryList from '../components/InventoryList.vue'
import InventoryBatch from '../components/InventoryBatch.vue'
import RepairList from '../components/RepairList.vue'
import RepairStats from '../components/RepairStats.vue'
import RepairDeptStats from '../components/RepairDeptStats.vue'
import PdfReminderList from '../components/PdfReminderList.vue'
import MeasurementReminderList from '../components/MeasurementReminderList.vue'
import SitePerformanceList from '../components/SitePerformanceList.vue'
import SafetyValveList from '../components/SafetyValveList.vue'
import QualificationDownload from '../views/QualificationDownload.vue'
import MpUserList from '../components/MpUserList.vue'
import MonitorStatUpload from '../components/MonitorStatUpload.vue'
import DepartmentList from '../components/DepartmentList.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      { path: '', name: 'Welcome', component: Welcome },
      { path: 'equipment', name: 'Equipment', component: EquipmentTable, meta: { hideExpiryCarousel: true } },
      { path: 'equipment/inventory', name: 'EquipmentInventory', component: InventoryList, meta: { hideExpiryCarousel: true } },
      { path: 'equipment/inventory-batches', name: 'InventoryBatches', component: InventoryBatch, meta: { hideExpiryCarousel: true } },
      { path: 'equipment/repair', name: 'EquipmentRepair', component: RepairList, meta: { hideExpiryCarousel: true } },
      { path: 'repair/stats', name: 'RepairStats', component: RepairStats, meta: { hideExpiryCarousel: true } },
      { path: 'repair/dept-stats', name: 'RepairDeptStats', component: RepairDeptStats, meta: { hideExpiryCarousel: true } },
      { path: 'pdf-reminder', name: 'PdfReminder', component: PdfReminderList, meta: { hideExpiryCarousel: true } },
      { path: 'report-reminder/measurement', name: 'MeasurementReminder', component: MeasurementReminderList, meta: { hideExpiryCarousel: true } },
      { path: 'report-reminder/site-performance', name: 'SitePerformanceReminder', component: SitePerformanceList, meta: { hideExpiryCarousel: true } },
      { path: 'report-reminder/safety-valve', name: 'SafetyValveReminder', component: SafetyValveList, meta: { hideExpiryCarousel: true } },
      { path: 'mp-users', name: 'MpUsers', component: MpUserList, meta: { hideExpiryCarousel: true } },
      { path: 'monitor-stat', name: 'MonitorStat', component: MonitorStatUpload, meta: { hideExpiryCarousel: true } },
      { path: 'departments', name: 'Departments', component: DepartmentList, meta: { hideExpiryCarousel: true } },
    ],
  },
  { path: '/login', name: 'Login', component: Login, meta: { hideExpiryCarousel: true } },
  { path: '/qualification/:id', name: 'QualificationDownload', component: QualificationDownload },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 路由守卫：未登录（无 Web Token）一律跳登录页；登录页本身放行
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next()
    return
  }
  const token = localStorage.getItem('ems_web_token')
  if (!token) {
    next({ name: 'Login' })
    return
  }
  next()
})

export default router
